import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-priority',
  templateUrl: './priority.component.html',
  styleUrls: ['./priority.component.scss'],
  standalone: false
})
export class PriorityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
